<template>
  <div class="flex items-center px-4">
    <button
      type="button"
      class="flex items-center justify-center flex-none text-gray-400 hover:text-gray-500"
      @click.stop="$emit('on-previous-month')"
    >
      <ChevronLeftIcon class="w-8 h-8" aria-hidden="true" />
    </button>
    <div class="mx-4">
      <p class="cursor-pointer text-primary">
        {{ monthSelected }}, {{ yearsSelected }}
      </p>
    </div>
    <button
      type="button"
      class="flex items-center justify-center flex-none text-gray-400 hover:text-gray-500"
      @click.stop="$emit('on-next-month')"
    >
      <ChevronRightIcon class="w-8 h-8" aria-hidden="true" />
    </button>
  </div>
</template>

<script>
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/vue/solid";
export default {
  name: "PeriodicComponent",
  components: {
    ChevronLeftIcon,
    ChevronRightIcon,
  },
  props: {
    monthSelected: {
      type: String,
      required: true,
    },
    yearsSelected: {
      type: String,
      required: true,
    },
  },
};
</script>
